import { alpha } from '@mui/material/styles';
import colors from '../theme/colors';
import palette from '../theme/palette';

const styleOverrides = {
  root: {
    backgroundColor: alpha(colors.brandPrimary[500], 0.1),
    color: palette.primary.main,
  },
};

export default styleOverrides;
